export default "__VITE_ASSET__D1VYOFjd__"